import { render, staticRenderFns } from "./WithValidation.vue?vue&type=template&id=2b41234e&"
import script from "./WithValidation.vue?vue&type=script&lang=js&"
export * from "./WithValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports